"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQueryParameter = void 0;
const getQueryParameter = param => {
  if (typeof window === 'undefined') {
    return null;
  }
  return new URLSearchParams(window.location.search).get(param);
};
exports.getQueryParameter = getQueryParameter;
